const toFixed = (v, i) => parseFloat(v).toFixed(i)

// 値をFloatに変換してiまでの小数点を表示したものを返す
export default toFixed



// WEBPACK FOOTER //
// ./src/utils/toFixed.js